import { Translations } from "../logic";
import { ApiListItem, ApiListItemType, CalculationStatus, TaxcardState, WelcomeDataWorker } from "../model";
import { OData, ODataQueryOptions, ODataResult } from "../util";
import { Ajax } from "./infra";

/**
 * Methods for testing the API.
 * Note that getWelcomeDataWorker() is currently used in Wecome component.
 * TODO: Remove getWelcomeDataWorker() and then remove the entire class.
 */
export class Overview {

  /**
   * For NG1-dependency injection
   * @ignore
   */
  public static $inject = ["AjaxNg1"];

  constructor(private ajax: Ajax) { }

  /**
   * Makes an OData query over all objects within the current account.
   * @param query The options for the query: Filter, search sort etc.
   * This is either a strongly typed object or query string that is added directly.
   */
  public getAllData(query: ODataQueryOptions | string): Promise<ODataResult<ApiListItem>> {
    return OData.getOData<ApiListItem>("/v03-rc/api/overview/all", query, this.ajax);
  }

  /**
   * Gets the welcome page data for a Worker account.
   */
  public getWelcomeDataWorker(): Promise<WelcomeDataWorker> {
    return this.ajax.getJSON("/v03-rc/api/overview/welcome-worker").then((data: WelcomeDataWorker) => {
      for (const item of data.timeline) {
        item.shortText = this.getShortMessage(item);
      }
      return data;
    });
  }
  private getShortMessage(item: ApiListItem) {
    switch (item.type) {
      case ApiListItemType.Calculation:
      case ApiListItemType.CalculationPaid:
        {
          const status = item.status as CalculationStatus;
          switch (status) {
            case CalculationStatus.WorkerRequested:
              return Translations.get("SALAXY.CORE.WorkerTimeline.shortMessages.calculation.workerRequested", {name: item.otherPartyInfo.avatar.displayName});
            case CalculationStatus.WorkerRequestDeclined:
              return Translations.get("SALAXY.CORE.WorkerTimeline.shortMessages.calculation.workerRequestDeclined", {name: item.otherPartyInfo.avatar.displayName});
            case CalculationStatus.WorkerRequestAccepted:
              return Translations.get("SALAXY.CORE.WorkerTimeline.shortMessages.calculation.workerRequestAccepted", {name: item.otherPartyInfo.avatar.displayName});
            case CalculationStatus.Draft:
              return Translations.get("SALAXY.CORE.WorkerTimeline.shortMessages.calculation.draft");
            case CalculationStatus.PaymentWorkerCopy:
              return Translations.get("SALAXY.CORE.WorkerTimeline.shortMessages.calculation.paymentWorkerCopy", {name: item.otherPartyInfo.avatar.displayName });
            default:
              return Translations.get("SALAXY.CORE.WorkerTimeline.shortMessages.calculation.default", {status: Translations.get("SALAXY.ENUM.CalculationStatus." + status) });
          }
        }
      case ApiListItemType.PersonAccount:
        return Translations.get("SALAXY.CORE.WorkerTimeline.shortMessages.personAccount");
      case ApiListItemType.Employment:
        return Translations.get("SALAXY.CORE.WorkerTimeline.shortMessages.employmentDefault", {name: item.ownerInfo.avatar.displayName});
      case ApiListItemType.Taxcard:
        {
          const status = item.status as TaxcardState;
          switch (status) {
            case TaxcardState.Shared:
              return Translations.get("SALAXY.CORE.WorkerTimeline.shortMessages.taxcard.shared");
            case TaxcardState.SharedApproved:
              return Translations.get("SALAXY.CORE.WorkerTimeline.shortMessages.taxcard.sharedApproved", {name: item.ownerInfo.avatar.displayName});
            case TaxcardState.SharedRejected:
            case TaxcardState.SharedRejectedWithoutOpen:
              return Translations.get("SALAXY.CORE.WorkerTimeline.shortMessages.taxcard.sharedRejected", {name: item.ownerInfo.avatar.displayName});
            case TaxcardState.SharedWaiting:
              return Translations.get("SALAXY.CORE.WorkerTimeline.shortMessages.taxcard.sharedWaiting", {name: item.ownerInfo.avatar.displayName});
            case TaxcardState.EmployerAdded:
            case TaxcardState.Approved:
              return Translations.get("SALAXY.CORE.WorkerTimeline.shortMessages.taxcard.approved", {name: item.ownerInfo.avatar.displayName});
            case TaxcardState.VerifiedVero:
              return Translations.get("SALAXY.CORE.WorkerTimeline.shortMessages.taxcard.verifiedVero", {name: item.ownerInfo.avatar.displayName});
            default:
              return Translations.get("SALAXY.CORE.WorkerTimeline.shortMessages.taxcard.default", {status: item.status});
          }
        }
      default:
        return Translations.get("SALAXY.CORE.WorkerTimeline.shortMessages.timelineType", {type: item.type});
    }
  }
}
